// Maps a strategy id to its hand-written product brief. The transcript renderer
// appends the resolved brief as its final section. Briefs are plain strings
// (markdown-ish prose) shipped as `.ts` modules so they resolve uniformly across
// the client build, the server build, and vitest without bundler `?raw` plumbing.

import { cmTwoBrief } from './cmTwo';
import { lincolnMoneyGuardBrief } from './lincolnMoneyGuard';
import { nylAssetFlexBrief } from './nylAssetFlex';
import { oaAssetCareBrief } from './oaAssetCare';
import { traditionalLtcBrief } from './traditionalLtc';

const BRIEFS: Record<ProjectionStrategyId, string> = {
  'cm-two': cmTwoBrief,
  'oa-asset-care': oaAssetCareBrief,
  'nyl-asset-flex': nylAssetFlexBrief,
  'lincoln-money-guard': lincolnMoneyGuardBrief,
  'traditional-ltc': traditionalLtcBrief,
};

export function getBriefForStrategy(strategyId: ProjectionStrategyId): string {
  return BRIEFS[strategyId];
}
